// extracted by mini-css-extract-plugin
export var root = "H_wl";
export var wrapper = "H_pM";
export var image = "H_wm d_v d_x d_V";
export var crop = "H_wn";
export var round = "H_wp";
export var fixedHeight = "H_wq";